export class VersionsDetailsController {
    constructor($q, $state, $timeout, JFrogEventBus, ComponentsDao, $stateParams,XRayUtils) {
        this.$timeout = $timeout;
        this.jfrogEventBus = JFrogEventBus;
        this.componentsDao = ComponentsDao;
        this.xrayUtils = XRayUtils;
        this.$state = $state;
        this.$q = $q;
        this.$stateParams = $stateParams;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.vsApi = {};
        this.getInternalVersions();

        let removeGenerlaVersionData = JFrogEventBus.register(this.EVENTS.CUSTOM_ISSUE_INJECTED, () => {

            this.$timeout(() => {
                this.getInternalVersions();
            }, 500)

        });


    }//ctor

    setVersion() {

        this.$widgetObject.model.sharedData.currentVersion = this.currentVersion;
    }

    getVersionInfo(index, ver) {

        //console.log('getting version info', index, ver)
        if (ver.type !== 'public') {
            if (ver.permissions.readable) {

                this.latestInternalVerSelected = ver;
                if (!this.$widgetObject.model.sharedData.currentVersion) {
                    this.$widgetObject.model.sharedData.currentVersion = {};
                }
                this.latestInternalIndexSelected = index;
                this.selectedVersionIndex = index;
                this.$widgetObject.model.sharedData.currentVersion = ver;
                this.currentVersion = ver;
                this.$widgetObject.model.sharedData.isPublicSelected = false;
                this.jfrogEventBus.dispatch(this.EVENTS.COMPONENT_VERSION_SELECTED, ver);
            }
        } else {

            this.selectedVersionIndex = index;
            this.$widgetObject.model.sharedData.currentVersion = ver;
            this.currentVersion = ver.version_number;
            this.$widgetObject.model.sharedData.isPublicSelected = true;
        }

    }

    scrollToVersion() {
        $('.card.stretch').animate({scrollTop: $($('.selected')[0]).offset().top - 350}, 1000);
    }

    filterVersion() {

        if (this.filter.includePublic) {
            this.getPublicVersions().then(() => {

                this.versionToShow = this.mixedVersions.versions;
                this.selectedVersionIndex = _.findIndex(this.mixedVersions.versions, 'version_number',
                    this.currentVersion.version_number);

                this.$timeout(() => {
                    this.scrollToVersion();
                }, 1000)

            });

        } else {
            //console.log('Selected version is ', this.latestInternalIndexSelected)
            this.selectedVersionIndex = this.latestInternalIndexSelected;
            this.versionToShow = this.internalVersions;


            this.selectedVersionIndex = _.findIndex(this.versionToShow, 'version_number',
                this.latestInternalVerSelected.version_number);

            this.getVersionInfo(this.latestInternalIndexSelected, this.latestInternalVerSelected);
        }
    }

    hasPublic() {
        if (this.$widgetObject.model.sharedData.compDetails) {
            if (this.$widgetObject.model.sharedData.compDetails.general_details.latest_versions.public_version) {

                return true;
            }
        }
        return false;
    }

    getInternalVersions() {


        this.componentsDao.getInternalVersions({$suppress_toaster: true, $no_spinner: true}, {
            package_id: this.$stateParams.componentID
        }).$promise.then((details) => {
            this.selectedVersionIndex = _.findIndex(details.versions, 'permissions.readable', true);
            this.latestInternalIndexSelected = _.findIndex(details.versions, 'permissions.readable', true);

            if (this.$stateParams.componentVersion !== '' && _.findIndex(details.versions, 'version_number',
                    this.$stateParams.componentVersion) > -1) {
                this.selectedVersionIndex = _.findIndex(details.versions, 'version_number',
                    this.$stateParams.componentVersion);
                this.latestInternalIndexSelected = _.findIndex(details.versions, 'version_number',
                    this.$stateParams.componentVersion);
                this.getVersionInfo(this.selectedVersionIndex, details.versions[this.selectedVersionIndex]);
                this.$widgetObject.model.sharedData.currentVersion = details.versions[this.selectedVersionIndex];

            }
            else {

                if (details.versions) {
                    this.currentVersion = details.versions[0];
                    this.latestInternalVerSelected = details.versions[0];
                    this.$widgetObject.model.sharedData.currentVersion = details.versions[0];
                }
                this.latestInternalIndexSelected = _.findIndex(details.versions, 'permissions.readable', true);

                this.getVersionInfo(this.latestInternalIndexSelected,
                    details.versions[this.latestInternalIndexSelected]);

            }
            if (!_.isEmpty(details)) {

                if (!_.isEmpty(details)) {
                    //this.buildVersions(details.versions)
                    this.internalVersions = details.versions;
                    this.versionToShow = this.internalVersions;
                    this.$widgetObject.model.sharedData.currentInternalVersions = _.map(details.versions,
                        'version_number');
                }

                this.$widgetObject.showSpinner = false;
            }

        });
    }

    convertSeverity(severity) {
     return this.xrayUtils.convertSeverityStatus(severity)
    }

    getPublicVersions() {
        let defer = this.$q.defer();

        this.componentsDao.getPublicVersions({$suppress_toaster: true, $no_spinner: true}, {
            package_id: this.$stateParams.componentID,
            versions: this.internalVersions
        }).$promise.then((details) => {
            //console.log('details of mixed versions are : ', details)
            this.mixedVersions = details;

            defer.resolve();
        });
        return defer.promise;
    }
}



// WEBPACK FOOTER //
// ./modules/xray/componentsPage_widgets/latest_versions_widget/latest_versions.controller.js